import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AssociatesEntityEffects } from './associates.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AssociatesEntityEffects])]
})
export class AssociatesEntityModule {}
